module.exports = __webpack_public_path__ + "static/media/galway-20.105f3a70.jpg";